export const environment = {
  production: true,
  // BASE_URL: 'http://dev.algoworks.com/greenlight-backend/api/'
   BASE_URL: 'https://api.greenlitecheckin.net/api/'
  // BASE_URL: 'https://stagingapi.greenlitecheckin.net/api/'
  // BASE_URL: 'http://localhost:8000/api/'
};
